import React from "react";

export const BetaBarTemplate = (): JSX.Element => {
    return (<div className="flex p-2 bg-tag-beta w-max border rounded-md border-none text-black font-medium">👨‍🔧🛠 This feature is currently in its Beta (testing) phase</div>)
}